import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { StartManualAutomationModule } from '@galaxy/automata/shared';
import { ItemSearchSelectFilterModule } from '@galaxy/inventory-ui';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { VaFilterModule, VaMultiSelectModule, VaSearchSelectModule, VaTableModule } from '@vendasta/uikit';
import { AddressCellModule } from '../common/address-cell';
import { EmptyTablePlaceholderComponent } from '../common/empty-table-placeholder.component';
import { PricePipe } from '../common/pipes/price.pipe';
import { VaButtonComponent } from '../common/va-button.component';
import { DatetimePickerModule } from '../common/va-datetime-picker';
import { ProductService } from '../core/product.service';
import { TagService } from '../core/tag.service';
import { ActionListsAccountsComponent } from './accounts/action-lists-accounts.component';
import { ActionListsAccountsStoreService } from './accounts/action-lists-accounts.store.service';
import { RemoveAccountDialogComponent } from './accounts/remove-acccount-dialog.component';
import { ActionListsDetailsComponent } from './action-lists-details.component';
import { ActionListsDetailsStoreService } from './action-lists-details.store.service';
import { ActionListsOverviewComponent } from './action-lists-overview.component';
import { ActionListsApiService } from './action-lists.api.service';
import { ActionListsStoreService } from './action-lists.store.service';
import {
  ActionListDialog,
  ActionsApiService,
  ActivateItemDialog,
  ActivateProductDialog,
  AddTagsDialog,
  ChangeMarketDialog,
  CreateBrandReportDialog,
  CreateRefreshSnapshotDialog,
  ExportAccountDataDialog,
  PauseCampaignDialog,
} from './actions';
import { AddToCampaignDialogComponent } from './actions/add-to-campaign-dialog.component';
import { AddToListDialogComponent } from './actions/add-to-list-dialog.component';
import { CreateListDialogComponent } from './actions/create-action-list-dialog.component';
import { DeleteListDialogComponent } from './actions/delete-action-list-dialog.component';
import { StartAutomationDialogComponent } from './actions/start-automation-dialog.component';
import { ViewActionListHistoryDialogComponent } from './actions/view-action-list-history-dialog.component';
import { ActionListsHistoryModule } from './history/action-lists-history.module';
import { ActionListTagsDialogComponent } from './history/action-lists-tags-dialog.component';
import { UserListModule } from './users/user-list.module';

@NgModule({
  imports: [
    ActionListsHistoryModule,
    CommonModule,
    VaTableModule,
    RouterModule,
    TranslateModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    DatetimePickerModule,
    MatSelectModule,
    MatCardModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatInputModule,
    MatIconModule,
    MatMenuModule,
    MatTabsModule,
    MatTableModule,
    MatChipsModule,
    MatListModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    AddressCellModule,
    UserListModule,
    GalaxyPipesModule,
    GalaxyPageModule,
    StartManualAutomationModule,
    GalaxyAlertModule,
    GalaxySnackbarModule,
    AddToCampaignDialogComponent,
    ItemSearchSelectFilterModule,
    EmptyTablePlaceholderComponent,
    VaButtonComponent,
    VaFilterModule,
    VaMultiSelectModule,
    VaSearchSelectModule,
    PricePipe,
  ],
  declarations: [
    ActionListDialog,
    ActionListsOverviewComponent,
    ActionListsDetailsComponent,
    ActionListsAccountsComponent,
    ActionListTagsDialogComponent,
    AddToListDialogComponent,
    DeleteListDialogComponent,
    CreateListDialogComponent,
    PauseCampaignDialog,
    CreateRefreshSnapshotDialog,
    ExportAccountDataDialog,
    ActivateProductDialog,
    ChangeMarketDialog,
    AddTagsDialog,
    CreateBrandReportDialog,
    ActivateItemDialog,
    RemoveAccountDialogComponent,
    ViewActionListHistoryDialogComponent,
    StartAutomationDialogComponent,
  ],
  exports: [
    ActionListsOverviewComponent,
    ActionListsDetailsComponent,
    ActionListsAccountsComponent,
    AddTagsDialog,
    ActionListDialog,
    AddToCampaignDialogComponent,
    PauseCampaignDialog,
    StartAutomationDialogComponent,
    ChangeMarketDialog,
    ViewActionListHistoryDialogComponent,
  ],
  providers: [
    ActionListsApiService,
    ActionListsStoreService,
    ActionListsAccountsStoreService,
    ActionListsDetailsStoreService,
    ActionsApiService,
    ProductService,
    TagService,
    {
      provide: 'markets$',
      useExisting: 'USER_ACCESSIBLE_MARKETS',
    },
  ],
})
export class ActionListsModule {}
